import { creatorsReportEndpointIds } from 'root/src/shared/creatorsReport/creatorsReport.constants';
import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
export const cronCreateCreatorsReportEndpoint = {
    [creatorsReportEndpointIds.CRON_CREATE_CREATORS_REPORT]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
        isLowSpec: true,
    },
};
